import { useState, useEffect, useCallback, useRef } from "react";
import "./Events.css";

// export default function Events() {
//     const [events, setEvents] = useState([]);
//     const [editId, setEditId] = useState(null);
//     const [filter, setFilter] = useState("All Categories");
//     const [sortOrder, setSortOrder] = useState("upcoming-first");
//     const [searchTerm, setSearchTerm] = useState("");
//     const [selectedEvent, setSelectedEvent] = useState(null);
//     const [showCreateModal, setShowCreateModal] = useState(false);
//     const [showViewModal, setShowViewModal] = useState(false);
//     const [imageFile, setImageFile] = useState(null);
//     const [imagePreview, setImagePreview] = useState(null);
//     const [loading, setLoading] = useState(false);
//     const [isProcessing, setIsProcessing] = useState(false);

//     // Ref so we can programmatically .click() and .reset() the hidden file <input>.
//     // This guarantees onChange fires even when the user re-selects the same file.
//     const fileInputRef = useRef(null);
//     const [currentPage, setCurrentPage] = useState(1);
//     const [totalPages, setTotalPages] = useState(1);
//     const [totalCount, setTotalCount] = useState(0);
//     const ITEMS_PER_PAGE = 5; // must match backend $limit

//     // ── Form fields ──
//     const defaultForm = () => ({
//         title: "",
//         category: "Healthcare",
//         description: "",
//         status: "Upcoming",
//         date: "",
//         fullDate: "",
//         code: `EVT${Date.now().toString().slice(-6)}`,
//         goal: "0,000",
//         type: "health",
//         location: "",
//         contactEmail: "",
//         contactPhone: "",
//         totalSpots: "100",
//         registered: "0",
//         progress: "0"
//     });

//     const [formData, setFormData] = useState(defaultForm());
//     const [errors, setErrors] = useState({});

//     const categories = ["Healthcare", "Education", "Tracking", "Activism", "Environment", "Other"];
//     const img_URL = process.env.REACT_APP_API_URL; // for displaying existing images

//     // ─────────────────────────────────────────────────────
//     // SAFE JSON PARSER
//     // Reads the raw body as text first.  When PHP crashes
//     // (uncaught PDOException → HTML error page) we log the
//     // actual PHP error to the console instead of a useless
//     // "unexpected token <" SyntaxError.
//     // ─────────────────────────────────────────────────────
//     const safeJson = async (res) => {
//         const text = await res.text();
//         try {
//             return JSON.parse(text);
//         } catch {
//             console.error("═══ RAW PHP RESPONSE (not JSON) ═══\n", text);
//             throw new Error(`Server returned HTTP ${res.status} — see console for details`);
//         }
//     };

//     // ─────────────────────────────────────────────────────
//     // FETCH  –  honours backend pagination (?page=N)
//     // ─────────────────────────────────────────────────────
//     const fetchEvents = useCallback(async (page = 1) => {
//         setLoading(true);
//         try {
//             const res = await fetch(
//                 `${process.env.REACT_APP_API_URL}Event.php?page=${page}`
//             );
//             const data = await safeJson(res);

//             if (data.success && Array.isArray(data.data)) {
//                 // Hydrate full image URLs
//                 const eventsWithImages = data.data.map((event) => ({
//                     ...event,
//                     image_url: event.image ? `${img_URL}${event.image}` : null
//                 }));

//                 setEvents(eventsWithImages);

//                 // Store pagination meta from backend
//                 if (data.pagination) {
//                     setCurrentPage(data.pagination.page);
//                     setTotalPages(data.pagination.total_pages);
//                     setTotalCount(data.pagination.total);
//                 }
//             } else {
//                 console.error("Failed to fetch events:", data.message || "Unknown error");
//                 setEvents([]);
//             }
//         } catch (err) {
//             console.error("Error fetching events:", err);
//             setEvents([]);
//         } finally {
//             setLoading(false);
//         }
//     }, []);

//     useEffect(() => {
//         fetchEvents(1);
//     }, [fetchEvents]);

//     // ─────────────────────────────────────────────────────
//     // IMAGE HANDLING
//     // ─────────────────────────────────────────────────────
//     const handleImageChange = (e) => {
//         const file = e.target.files[0];
//         if (!file) return;

//         const validTypes = ["image/jpeg", "image/png", "image/webp", "image/jpg"];
//         if (!validTypes.includes(file.type)) {
//             alert("Only JPG, PNG, and WebP images are allowed");
//             return;
//         }

//         if (file.size > 2 * 1024 * 1024) {
//             alert("Image must be under 2MB");
//             return;
//         }

//         setImageFile(file);

//         const reader = new FileReader();
//         reader.onloadend = () => setImagePreview(reader.result);
//         reader.readAsDataURL(file);
//     };

//     const removeImage = () => {
//         setImageFile(null);
//         setImagePreview(null);
//         // Reset the native <input type="file"> so onChange fires again
//         // even if the user picks the exact same file afterwards.
//         if (fileInputRef.current) {
//             fileInputRef.current.value = "";
//         }
//     };

//     // ─────────────────────────────────────────────────────
//     // VALIDATION
//     // ─────────────────────────────────────────────────────
//     const validateForm = () => {
//         const newErrors = {};

//         if (!formData.title.trim()) {
//             newErrors.title = "Event title is required";
//         } else if (formData.title.length < 5) {
//             newErrors.title = "Title must be at least 5 characters";
//         }

//         if (!formData.description.trim()) {
//             newErrors.description = "Description is required";
//         } else if (formData.description.length < 20) {
//             newErrors.description = "Description must be at least 20 characters";
//         }

//         if (!formData.date) {
//             newErrors.date = "Event date is required";
//         } else if (!editId && new Date(formData.date) < new Date()) {
//             newErrors.date = "Event date cannot be in the past";
//         }

//         if (!formData.location.trim()) {
//             newErrors.location = "Location is required";
//         }

//         if (!formData.contactEmail.trim()) {
//             newErrors.contactEmail = "Contact email is required";
//         } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.contactEmail)) {
//             newErrors.contactEmail = "Invalid email format";
//         }

//         if (!formData.contactPhone.trim()) {
//             newErrors.contactPhone = "Contact phone is required";
//         } else if (!/^\d{10}$/.test(formData.contactPhone)) {
//             newErrors.contactPhone = "Phone number must be 10 digits";
//         }

//         if (!formData.totalSpots || parseInt(formData.totalSpots) < 1) {
//             newErrors.totalSpots = "Total spots must be at least 1";
//         }

//         setErrors(newErrors);
//         return Object.keys(newErrors).length === 0;
//     };

//     const handleChange = (e) => {
//         const { name, value } = e.target;
//         const newFormData = { ...formData, [name]: value };

//         if (name === "date" && value) {
//             try {
//                 const dateObj = new Date(value);
//                 newFormData.fullDate = dateObj.toLocaleDateString("en-US", {
//                     year: "numeric",
//                     month: "long",
//                     day: "numeric"
//                 });
//             } catch {
//                 newFormData.fullDate = value;
//             }
//         }

//         if (name === "registered" || name === "totalSpots") {
//             const registered = parseInt(newFormData.registered) || 0;
//             const totalSpots = parseInt(newFormData.totalSpots) || 1;
//             newFormData.progress = Math.round((registered / totalSpots) * 100);
//         }

//         setFormData(newFormData);
//         if (errors[name]) setErrors((prev) => ({ ...prev, [name]: "" }));
//     };

//     // ─────────────────────────────────────────────────────
//     // MODAL HELPERS
//     // ─────────────────────────────────────────────────────
//     const openCreateModal = () => {
//         setFormData(defaultForm());
//         setEditId(null);
//         setImageFile(null);
//         setImagePreview(null);
//         setErrors({});
//         setShowCreateModal(true);
//     };

//     const openEditModal = (event) => {
//         setFormData({
//             title: event.title || "",
//             category: event.category || "Healthcare",
//             description: event.description || "",
//             status: event.status || "Upcoming",
//             date: event.date || "",
//             fullDate: event.fullDate || "",
//             code: event.code || `EVT${Date.now().toString().slice(-6)}`,
//             goal: event.goal || "0,000",
//             type: event.type || "health",
//             location: event.location || "",
//             contactEmail: event.contactEmail || "",
//             contactPhone: event.contactPhone || "",
//             totalSpots: event.totalSpots?.toString() || "100",
//             registered: event.registered?.toString() || "0",
//             progress: event.progress?.toString() || "0"
//         });
//         setEditId(event.id);
//         setImageFile(null);
//         // Show existing image; a new file upload will overwrite it
//         setImagePreview(event.image_url || null);
//         setErrors({});
//         setShowCreateModal(true);
//     };

//     const closeModal = () => {
//         setShowCreateModal(false);
//         setEditId(null);
//         setFormData(defaultForm());
//         setImageFile(null);
//         setImagePreview(null);
//         setErrors({});
//     };

//     // ─────────────────────────────────────────────────────
//     // SUBMIT  –  both CREATE and UPDATE use FormData so that
//     //            $_POST  and  $_FILES are populated on the
//     //            PHP side.  PUT is signalled via the
//     //            X-HTTP-Method-Override header.
//     // ─────────────────────────────────────────────────────
//     // const handleSubmit = async () => {
//     //     if (!validateForm()) {
//     //         alert("Please fix validation errors");
//     //         return;
//     //     }

//     //     setIsProcessing(true);

//     //     // Build a single FormData payload for both create & update.
//     //     // Every value is explicitly converted to String so that FormData
//     //     // never sends a bare number/object — some browsers mangle those.
//     //     const fd = new FormData();
//     //     Object.entries(formData).forEach(([key, val]) => {
//     //         fd.append(key, val != null ? String(val) : "");
//     //     });

//     //     // Attach the actual File object (only present when user picked a new file).
//     //     // Third arg = filename — required; some browsers drop File.name otherwise
//     //     // and PHP receives "blob" which fails the extension check.
//     //     if (imageFile) {
//     //         fd.append("image", imageFile, imageFile.name);
//     //     }

//     //     try {
//     //         const headers = {};
//     //         if (editId) {
//     //             fd.append("id", String(editId));
//     //             // Two-layer override so the PUT reaches PHP even when
//     //             // a reverse-proxy strips the custom header:
//     //             //   Layer 1 – standard header (works on most hosts)
//     //             headers["X-HTTP-Method-Override"] = "PUT";
//     //             //   Layer 2 – body field (Rails-style fallback)
//     //             fd.append("_method", "PUT");
//     //         }

//     //         const res = await fetch(`${process.env.REACT_APP_API_URL}Event.php`, {
//     //             method: "POST",
//     //             headers,          // NOTE: do NOT set Content-Type; let the browser
//     //             body: fd          //       set it automatically with the boundary.
//     //         });

//     //         const result = await safeJson(res);

//     //         if (result.success) {
//     //             alert(editId ? "Event Updated Successfully" : "Event Created Successfully");
//     //             closeModal();
//     //             fetchEvents(currentPage); // refresh the current page
//     //         } else {
//     //             alert(result.error || result.message || "Operation failed");
//     //         }
//     //     } catch (err) {
//     //         console.error(err);
//     //         alert("Server error. Please try again.");
//     //     } finally {
//     //         setIsProcessing(false);
//     //     }
//     // };
//      const handleSubmit = async () => {
//     if (!validateForm()) {
//         alert("Please fix validation errors");
//         return;
//     }

//     setIsProcessing(true);

//     const fd = new FormData();
//     Object.entries(formData).forEach(([key, val]) => {
//         fd.append(key, val != null ? String(val) : "");
//     });

//     if (imageFile) {
//         fd.append("image", imageFile, imageFile.name);
//     }

//     try {
//         // ✅ Simplified: No custom headers, just _method field
//         if (editId) {
//             fd.append("id", String(editId));
//             fd.append("_method", "PUT");  // ← Only this, no X-HTTP-Method-Override
//         }

//         const res = await fetch(`${process.env.REACT_APP_API_URL}Event.php`, {
//             method: "POST",
//             body: fd
//             // NO headers at all - let browser handle it
//         });

//         const result = await safeJson(res);

//         if (result.success) {
//             alert(editId ? "Event Updated Successfully" : "Event Created Successfully");
//             closeModal();
//             fetchEvents(currentPage);
//         } else {
//             alert(result.error || result.message || "Operation failed");
//         }
//     } catch (err) {
//         console.error(err);
//         alert("Server error. Please try again.");
//     } finally {
//         setIsProcessing(false);
//     }
// };
//     // ─────────────────────────────────────────────────────
//     // DELETE
//     // ─────────────────────────────────────────────────────
//     const handleDelete = async (id) => {
//         if (!window.confirm("Are you sure you want to delete this event? This action cannot be undone.")) return;

//         setIsProcessing(true);
//         try {
//             const res = await fetch(`${process.env.REACT_APP_API_URL}Event.php`, {
//                 method: "DELETE",
//                 headers: { "Content-Type": "application/json" },
//                 body: JSON.stringify({ id: Number(id) })
//             });

//             const result = await safeJson(res);

//             if (result.success) {
//                 alert("Event deleted successfully!");
//                 // If we just deleted the last item on this page, go back one page
//                 const newPage =
//                     events.length === 1 && currentPage > 1 ? currentPage - 1 : currentPage;
//                 fetchEvents(newPage);
//             } else {
//                 alert(result.error || result.message || "Failed to delete event");
//             }
//         } catch (err) {
//             console.error("Error:", err);
//             alert("Failed to delete event. Please try again.");
//         } finally {
//             setIsProcessing(false);
//         }
//     };

//     // ─────────────────────────────────────────────────────
//     // STATUS CHANGE  –  uses FormData + X-HTTP-Method-Override
//     // ─────────────────────────────────────────────────────
//     const handleStatusChange = async (id, newStatus) => {
//         const event = events.find((e) => e.id === id);
//         if (!event) return;

//         setIsProcessing(true);
//         try {
//             const fd = new FormData();
//             fd.append("id",            String(id));
//             fd.append("_method",       "PUT");                    // body-level override fallback
//             fd.append("title",         event.title         || "");
//             fd.append("category",      event.category      || "");
//             fd.append("description",   event.description   || "");
//             fd.append("status",        newStatus);                // ← changed field
//             fd.append("date",          event.date          || "");
//             fd.append("fullDate",      event.fullDate      || "");
//             fd.append("code",          event.code          || "");
//             fd.append("goal",          event.goal          || "");
//             fd.append("type",          event.type          || "");
//             fd.append("location",      event.location      || "");
//             fd.append("contactEmail",  event.contactEmail  || "");
//             fd.append("contactPhone",  event.contactPhone  || "");
//             fd.append("totalSpots",    String(event.totalSpots  ?? 100));
//             fd.append("registered",    String(event.registered  ?? 0));
//             fd.append("progress",      String(event.progress    ?? 0));

//             const res = await fetch(`${process.env.REACT_APP_API_URL}Event.php`, {
//                 method: "POST",
//                 headers: { "X-HTTP-Method-Override": "PUT" },
//                 body: fd
//             });

//             const result = await safeJson(res);

//             if (result.success) {
//                 // Optimistic local update
//                 setEvents((prev) =>
//                     prev.map((e) => (e.id === id ? { ...e, status: newStatus } : e))
//                 );
//                 alert("Status updated successfully!");
//             } else {
//                 alert(result.error || result.message || "Failed to update status");
//             }
//         } catch (err) {
//             console.error("Error:", err);
//             alert("Failed to update status");
//         } finally {
//             setIsProcessing(false);
//         }
//     };

//     // ─────────────────────────────────────────────────────
//     // REGISTRATION (+1)  –  same FormData pattern
//     // ─────────────────────────────────────────────────────
//     const handleRegistration = async (id) => {
//         const event = events.find((e) => e.id === id);
//         if (!event) return;

//         if (event.status !== "Upcoming") {
//             alert("Cannot register for completed or cancelled events");
//             return;
//         }

//         const currentRegistered = parseInt(event.registered) || 0;
//         const totalSpots = parseInt(event.totalSpots) || 100;

//         if (currentRegistered >= totalSpots) {
//             alert("Event is full! No more spots available.");
//             return;
//         }

//         const newRegistered = currentRegistered + 1;
//         const newProgress = Math.round((newRegistered / totalSpots) * 100);

//         setIsProcessing(true);
//         try {
//             const fd = new FormData();
//             fd.append("id",            String(id));
//             fd.append("_method",       "PUT");                    // body-level override fallback
//             fd.append("title",         event.title         || "");
//             fd.append("category",      event.category      || "");
//             fd.append("description",   event.description   || "");
//             fd.append("status",        event.status        || "Upcoming");
//             fd.append("date",          event.date          || "");
//             fd.append("fullDate",      event.fullDate      || "");
//             fd.append("code",          event.code          || "");
//             fd.append("goal",          event.goal          || "");
//             fd.append("type",          event.type          || "");
//             fd.append("location",      event.location      || "");
//             fd.append("contactEmail",  event.contactEmail  || "");
//             fd.append("contactPhone",  event.contactPhone  || "");
//             fd.append("totalSpots",    String(totalSpots));
//             fd.append("registered",    String(newRegistered));     // ← changed
//             fd.append("progress",      String(newProgress));       // ← changed

//             const res = await fetch(`${process.env.REACT_APP_API_URL}Event.php`, {
//                 method: "POST",
//                 headers: { "X-HTTP-Method-Override": "PUT" },
//                 body: fd
//             });

//             const result = await safeJson(res);

//             if (result.success) {
//                 setEvents((prev) =>
//                     prev.map((e) =>
//                         e.id === id
//                             ? {
//                                   ...e,
//                                   registered: newRegistered.toString(),
//                                   progress: newProgress.toString()
//                               }
//                             : e
//                     )
//                 );
//                 alert(`Registration added! Total registered: ${newRegistered}/${totalSpots}`);
//             } else {
//                 alert(result.error || result.message || "Failed to add registration");
//             }
//         } catch (err) {
//             console.error("Error:", err);
//             alert("Failed to add registration");
//         } finally {
//             setIsProcessing(false);
//         }
//     };

//     // ─────────────────────────────────────────────────────
//     // VIEW MODAL
//     // ─────────────────────────────────────────────────────
//     const handleViewDetails = (event) => {
//         setSelectedEvent(event);
//         setShowViewModal(true);
//     };

//     const closeViewModal = () => {
//         setShowViewModal(false);
//         setSelectedEvent(null);
//     };

//     // ─────────────────────────────────────────────────────
//     // CLIENT-SIDE FILTER & SORT  (applied to the current page's data)
//     // ─────────────────────────────────────────────────────
//     const filteredEvents = events.filter((event) => {
//         const matchesCategory = filter === "All Categories" || event.category === filter;
//         const matchesSearch =
//             searchTerm === "" ||
//             (event.title || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
//             (event.description || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
//             (event.location || "").toLowerCase().includes(searchTerm.toLowerCase());
//         return matchesCategory && matchesSearch;
//     });

//     const sortedEvents = [...filteredEvents].sort((a, b) => {
//         const dateA = new Date(a.date);
//         const dateB = new Date(b.date);
//         switch (sortOrder) {
//             case "upcoming-first":
//                 return dateA - dateB;
//             case "date-desc":
//                 return dateB - dateA;
//             case "upcoming-only":
//                 return a.status === "Upcoming" ? -1 : 1;
//             case "completed-first":
//                 return a.status === "Completed" ? -1 : 1;
//             case "registered-desc":
//                 return (parseInt(b.registered) || 0) - (parseInt(a.registered) || 0);
//             default:
//                 return 0;
//         }
//     });

//     const displayedEvents =
//         sortOrder === "upcoming-only"
//             ? sortedEvents.filter((e) => e.status === "Upcoming")
//             : sortedEvents;

//     // ─────────────────────────────────────────────────────
//     // PAGINATION HANDLERS
//     // ─────────────────────────────────────────────────────
//     const goToPage = (page) => {
//         if (page < 1 || page > totalPages) return;
//         fetchEvents(page);
//     };

//     // ─────────────────────────────────────────────────────
//     // STATISTICS  –  computed from ALL events across all pages;
//     //   re-fetch page 1 when filters change so counts stay in sync.
//     // ─────────────────────────────────────────────────────
//     const upcomingEvents = events.filter((e) => e.status === "Upcoming").length;
//     const completedEvents = events.filter((e) => e.status === "Completed").length;
//     const totalRegistrations = events.reduce(
//         (sum, e) => sum + (parseInt(e.registered) || 0),
//         0
//     );

//     // ─────────────────────────────────────────────────────
//     // DATE FORMATTER
//     // ─────────────────────────────────────────────────────
//     const formatDisplayDate = (dateString) => {
//         if (!dateString) return "Date not set";
//         try {
//             const date = new Date(dateString);
//             return date.toLocaleDateString("en-US", {
//                 year: "numeric",
//                 month: "short",
//                 day: "numeric"
//             });
//         } catch {
//             return dateString;
//         }
//     };

//     // ═════════════════════════════════════════════════════
//     // RENDER
//     // ═════════════════════════════════════════════════════
//     return (
//         <div className="events-admin">
//             {/* ── Header ── */}
//             <div className="events-header">
//                 <div className="header-top">
//                     <h2>
//                         <span>📅</span> Event Management
//                     </h2>
//                     <button className="btn-create" onClick={openCreateModal} disabled={isProcessing}>
//                         <span>+</span> Create New Event
//                     </button>
//                 </div>
//                 <p className="subtitle">Manage and organize all community events</p>

//                 {/* Filters */}
//                 <div className="filters-section">
//                     <div className="search-bar">
//                         <input
//                             type="text"
//                             placeholder="Search events by title, description, or location..."
//                             value={searchTerm}
//                             onChange={(e) => setSearchTerm(e.target.value)}
//                             disabled={isProcessing}
//                         />
//                     </div>
//                     <div className="filters">
//                         <div className="filter-group">
//                             <label>Category:</label>
//                             <select
//                                 value={filter}
//                                 onChange={(e) => setFilter(e.target.value)}
//                                 className="filter-select"
//                                 disabled={isProcessing}
//                             >
//                                 <option value="All Categories">All Categories</option>
//                                 {categories.map((cat) => (
//                                     <option key={cat} value={cat}>
//                                         {cat}
//                                     </option>
//                                 ))}
//                             </select>
//                         </div>
//                         <div className="filter-group">
//                             <label>Sort By:</label>
//                             <select
//                                 value={sortOrder}
//                                 onChange={(e) => setSortOrder(e.target.value)}
//                                 className="sort-select"
//                                 disabled={isProcessing}
//                             >
//                                 <option value="upcoming-first">Date (Earliest First)</option>
//                                 <option value="date-desc">Date (Latest First)</option>
//                                 <option value="upcoming-only">Upcoming Only</option>
//                                 <option value="completed-first">Completed First</option>
//                                 <option value="registered-desc">Most Registered</option>
//                             </select>
//                         </div>
//                     </div>
//                 </div>
//             </div>

//             {/* ── Loading ── */}
//             {loading ? (
//                 <div className="loading-state">
//                     <div className="loading-spinner"></div>
//                     <p>Loading events...</p>
//                 </div>
//             ) : (
//                 <>
//                     {/* ── Stats ── */}
//                     <div className="events-stats">
//                         <div className="stat-card">
//                             <div className="stat-icon">📅</div>
//                             <div className="stat-content">
//                                 <h3>{totalCount}</h3>
//                                 <p>Total Events</p>
//                             </div>
//                         </div>
//                         <div className="stat-card">
//                             <div className="stat-icon">⏳</div>
//                             <div className="stat-content">
//                                 <h3>{upcomingEvents}</h3>
//                                 <p>Upcoming</p>
//                             </div>
//                         </div>
//                         <div className="stat-card">
//                             <div className="stat-icon">✅</div>
//                             <div className="stat-content">
//                                 <h3>{completedEvents}</h3>
//                                 <p>Completed</p>
//                             </div>
//                         </div>
//                         <div className="stat-card">
//                             <div className="stat-icon">👥</div>
//                             <div className="stat-content">
//                                 <h3>{totalRegistrations}</h3>
//                                 <p>Total Registrations</p>
//                             </div>
//                         </div>
//                     </div>

//                     {/* ── Table ── */}
//                     <div className="events-list-container">
//                         <div className="list-header">
//                             <h3>All Events ({totalCount})</h3>
//                             <div className="table-actions">
//                                 <span className="results-count">
//                                     Showing {displayedEvents.length} of {totalCount} events
//                                     &nbsp;· Page {currentPage} of {totalPages}
//                                 </span>
//                             </div>
//                         </div>

//                         {displayedEvents.length === 0 ? (
//                             <div className="empty-state">
//                                 <div className="empty-icon">📅</div>
//                                 <p>No events found</p>
//                                 <p className="empty-subtext">
//                                     {searchTerm || filter !== "All Categories"
//                                         ? "Try a different search or filter"
//                                         : "Create your first event to get started"}
//                                 </p>
//                                 <button
//                                     className="btn-create-empty"
//                                     onClick={openCreateModal}
//                                     disabled={isProcessing}
//                                 >
//                                     Create New Event
//                                 </button>
//                             </div>
//                         ) : (
//                             <>
//                                 <div className="events-table">
//                                     <table>
//                                         <thead>
//                                             <tr>
//                                                 <th>Event</th>
//                                                 <th>Category</th>
//                                                 <th>Date</th>
//                                                 <th>Status</th>
//                                                 <th>Registrations</th>
//                                                 <th>Progress</th>
//                                                 <th>Actions</th>
//                                             </tr>
//                                         </thead>
//                                         <tbody>
//                                             {displayedEvents.map((event) => (
//                                                 <tr key={event.id}>
//                                                     <td className="event-info">
//                                                         <div className="event-title">
//                                                             {event.title || "Untitled Event"}
//                                                         </div>
//                                                         <div className="event-code">
//                                                             {event.code ||
//                                                                 `EVT${event.id.toString().slice(-6)}`}
//                                                         </div>
//                                                         {event.image_url && (
//                                                             <div
//                                                                 className="event-image-indicator"
//                                                                 title="Has image"
//                                                             >
//                                                                 📷
//                                                             </div>
//                                                         )}
//                                                     </td>
//                                                     <td className="event-category">
//                                                         <span
//                                                             className={`category-badge category-${(
//                                                                 event.type || "other"
//                                                             ).toLowerCase()}`}
//                                                         >
//                                                             {event.category || "Uncategorized"}
//                                                         </span>
//                                                     </td>
//                                                     <td className="event-date">
//                                                         {formatDisplayDate(event.date)}
//                                                     </td>
//                                                     <td className="event-status">
//                                                         <select
//                                                             value={event.status || "Upcoming"}
//                                                             onChange={(e) =>
//                                                                 handleStatusChange(event.id, e.target.value)
//                                                             }
//                                                             className={`status-select status-${(
//                                                                 event.status || "Upcoming"
//                                                             ).toLowerCase()}`}
//                                                             disabled={isProcessing}
//                                                         >
//                                                             <option value="Upcoming">Upcoming</option>
//                                                             <option value="Completed">Completed</option>
//                                                             <option value="Cancelled">Cancelled</option>
//                                                         </select>
//                                                     </td>
//                                                     <td className="event-registered">
//                                                         <div className="registration-count">
//                                                             {parseInt(event.registered) || 0} /{" "}
//                                                             {parseInt(event.totalSpots) || 100}
//                                                         </div>
//                                                         <div className="registration-text">Registered</div>
//                                                     </td>
//                                                     <td className="event-progress">
//                                                         <div className="progress-container">
//                                                             <div className="progress-bar">
//                                                                 <div
//                                                                     className="progress-fill"
//                                                                     style={{
//                                                                         width: `${Math.min(
//                                                                             100,
//                                                                             parseInt(event.progress) || 0
//                                                                         )}%`
//                                                                     }}
//                                                                 ></div>
//                                                             </div>
//                                                             <span className="progress-percentage">
//                                                                 {Math.min(
//                                                                     100,
//                                                                     parseInt(event.progress) || 0
//                                                                 )}
//                                                                 %
//                                                             </span>
//                                                         </div>
//                                                     </td>
//                                                     <td className="event-actions">
//                                                         <div className="action-buttons">
//                                                             <button
//                                                                 className="btn-view"
//                                                                 onClick={() => handleViewDetails(event)}
//                                                                 title="View Details"
//                                                                 disabled={isProcessing}
//                                                             >
//                                                                 👁️
//                                                             </button>
//                                                             <button
//                                                                 className="btn-edit"
//                                                                 onClick={() => openEditModal(event)}
//                                                                 title="Edit Event"
//                                                                 disabled={isProcessing}
//                                                             >
//                                                                 ✏️
//                                                             </button>
//                                                             <button
//                                                                 className="btn-register"
//                                                                 onClick={() =>
//                                                                     handleRegistration(event.id)
//                                                                 }
//                                                                 disabled={
//                                                                     isProcessing ||
//                                                                     event.status !== "Upcoming"
//                                                                 }
//                                                                 title="Add Registration"
//                                                             >
//                                                                 ➕
//                                                             </button>
//                                                             <button
//                                                                 className="btn-delete"
//                                                                 onClick={() => handleDelete(event.id)}
//                                                                 title="Delete Event"
//                                                                 disabled={isProcessing}
//                                                             >
//                                                                 🗑️
//                                                             </button>
//                                                         </div>
//                                                     </td>
//                                                 </tr>
//                                             ))}
//                                         </tbody>
//                                     </table>
//                                 </div>

//                                 {/* ── Pagination ── */}
//                                 <div className="pagination">
//                                     <button
//                                         className="pagination-btn prev"
//                                         onClick={() => goToPage(currentPage - 1)}
//                                         disabled={currentPage === 1 || isProcessing}
//                                     >
//                                         ← Previous
//                                     </button>

//                                     <div className="pagination-numbers">
//                                         {Array.from({ length: totalPages }, (_, i) => i + 1).map(
//                                             (num) => (
//                                                 <button
//                                                     key={num}
//                                                     className={`pagination-number ${
//                                                         currentPage === num ? "active" : ""
//                                                     }`}
//                                                     onClick={() => goToPage(num)}
//                                                     disabled={isProcessing}
//                                                 >
//                                                     {num}
//                                                 </button>
//                                             )
//                                         )}
//                                     </div>

//                                     <button
//                                         className="pagination-btn next"
//                                         onClick={() => goToPage(currentPage + 1)}
//                                         disabled={currentPage === totalPages || isProcessing}
//                                     >
//                                         Next →
//                                     </button>

//                                     <div className="page-info">
//                                         Page {currentPage} of {totalPages}
//                                     </div>
//                                 </div>
//                             </>
//                         )}
//                     </div>
//                 </>
//             )}

//             {/* ══════════════════════════════════════════════
//                 CREATE / EDIT MODAL
//                 ══════════════════════════════════════════════ */}
//             {showCreateModal && (
//                 <div className="modal-overlay">
//                     <div className="modal-container">
//                         <div className="modal-header">
//                             <h3>{editId ? "Edit Event" : "Create New Event"}</h3>
//                             <button className="close-btn" onClick={closeModal} disabled={isProcessing}>
//                                 ×
//                             </button>
//                         </div>

//                         <div className="modal-body">
//                             <div className="modal-form">
//                                 {/* Image Upload */}
//                                 <div className="form-group">
//                                     <label>Event Image</label>
//                                     <div className="image-upload-container">
//                                         {/* The hidden file input lives here ALWAYS (not inside a
//                                             conditional branch).  This keeps the DOM node stable
//                                             so the ref never goes stale. */}
//                                         <input
//                                             ref={fileInputRef}
//                                             type="file"
//                                             accept="image/jpeg,image/png,image/webp"
//                                             onChange={handleImageChange}
//                                             style={{ display: "none" }}
//                                             disabled={isProcessing}
//                                         />

//                                         {imagePreview ? (
//                                             <div className="image-preview">
//                                                 <img
//                                                     src={imagePreview}
//                                                     alt="Preview"
//                                                     style={{
//                                                         width: "100%",
//                                                         height: "auto",
//                                                         maxHeight: "200px",
//                                                         objectFit: "contain"
//                                                     }}
//                                                 />
//                                                 <div style={{ display: "flex", gap: "8px", marginTop: "8px" }}>
//                                                     <button
//                                                         type="button"
//                                                         className="remove-image-btn"
//                                                         onClick={removeImage}
//                                                         disabled={isProcessing}
//                                                     >
//                                                         Remove Image
//                                                     </button>
//                                                     <button
//                                                         type="button"
//                                                         className="remove-image-btn"
//                                                         onClick={() => fileInputRef.current && fileInputRef.current.click()}
//                                                         disabled={isProcessing}
//                                                     >
//                                                         Change Image
//                                                     </button>
//                                                 </div>
//                                             </div>
//                                         ) : (
//                                             <div
//                                                 className="image-upload-area"
//                                                 onClick={() => !isProcessing && fileInputRef.current && fileInputRef.current.click()}
//                                                 style={{ cursor: isProcessing ? "not-allowed" : "pointer" }}
//                                             >
//                                                 <div className="upload-icon">📷</div>
//                                                 <div className="upload-text">
//                                                     Click to upload event image
//                                                 </div>
//                                                 <div className="upload-subtext">
//                                                     JPG, PNG, WebP (max 2MB)
//                                                 </div>
//                                             </div>
//                                         )}
//                                     </div>
//                                 </div>

//                                 {/* Title + Category */}
//                                 <div className="form-row">
//                                     <div className="form-group">
//                                         <label>Event Title *</label>
//                                         <input
//                                             type="text"
//                                             name="title"
//                                             value={formData.title}
//                                             onChange={handleChange}
//                                             placeholder="Enter event title"
//                                             className={errors.title ? "error" : ""}
//                                             disabled={isProcessing}
//                                         />
//                                         {errors.title && (
//                                             <span className="error-text">{errors.title}</span>
//                                         )}
//                                     </div>
//                                     <div className="form-group">
//                                         <label>Category *</label>
//                                         <select
//                                             name="category"
//                                             value={formData.category}
//                                             onChange={handleChange}
//                                             disabled={isProcessing}
//                                         >
//                                             {categories.map((cat) => (
//                                                 <option key={cat} value={cat}>
//                                                     {cat}
//                                                 </option>
//                                             ))}
//                                         </select>
//                                     </div>
//                                 </div>

//                                 {/* Date + Code */}
//                                 <div className="form-row">
//                                     <div className="form-group">
//                                         <label>Event Date *</label>
//                                         <input
//                                             type="date"
//                                             name="date"
//                                             value={formData.date}
//                                             onChange={handleChange}
//                                             className={errors.date ? "error" : ""}
//                                             disabled={isProcessing}
//                                         />
//                                         {errors.date && (
//                                             <span className="error-text">{errors.date}</span>
//                                         )}
//                                     </div>
//                                     <div className="form-group">
//                                         <label>Event Code</label>
//                                         <input
//                                             type="text"
//                                             name="code"
//                                             value={formData.code}
//                                             onChange={handleChange}
//                                             placeholder="Event code"
//                                             disabled={isProcessing}
//                                         />
//                                     </div>
//                                 </div>

//                                 {/* Status + Type */}
//                                 <div className="form-row">
//                                     <div className="form-group">
//                                         <label>Status *</label>
//                                         <select
//                                             name="status"
//                                             value={formData.status}
//                                             onChange={handleChange}
//                                             disabled={isProcessing}
//                                         >
//                                             <option value="Upcoming">Upcoming</option>
//                                             <option value="Completed">Completed</option>
//                                             <option value="Cancelled">Cancelled</option>
//                                         </select>
//                                     </div>
//                                     <div className="form-group">
//                                         <label>Event Type</label>
//                                         <select
//                                             name="type"
//                                             value={formData.type}
//                                             onChange={handleChange}
//                                             disabled={isProcessing}
//                                         >
//                                             <option value="health">Health</option>
//                                             <option value="education">Education</option>
//                                             <option value="tracking">Tracking</option>
//                                             <option value="campaign">Campaign</option>
//                                             <option value="environment">Environment</option>
//                                             <option value="other">Other</option>
//                                         </select>
//                                     </div>
//                                 </div>

//                                 {/* Location */}
//                                 <div className="form-group">
//                                     <label>Location *</label>
//                                     <input
//                                         type="text"
//                                         name="location"
//                                         value={formData.location}
//                                         onChange={handleChange}
//                                         placeholder="Enter event location"
//                                         className={errors.location ? "error" : ""}
//                                         disabled={isProcessing}
//                                     />
//                                     {errors.location && (
//                                         <span className="error-text">{errors.location}</span>
//                                     )}
//                                 </div>

//                                 {/* Description */}
//                                 <div className="form-group">
//                                     <label>Description *</label>
//                                     <textarea
//                                         name="description"
//                                         value={formData.description}
//                                         onChange={handleChange}
//                                         placeholder="Describe the event in detail..."
//                                         rows="4"
//                                         className={errors.description ? "error" : ""}
//                                         disabled={isProcessing}
//                                     />
//                                     {errors.description && (
//                                         <span className="error-text">{errors.description}</span>
//                                     )}
//                                 </div>

//                                 {/* Contact */}
//                                 <div className="form-row">
//                                     <div className="form-group">
//                                         <label>Contact Email *</label>
//                                         <input
//                                             type="email"
//                                             name="contactEmail"
//                                             value={formData.contactEmail}
//                                             onChange={handleChange}
//                                             placeholder="contact@example.com"
//                                             className={errors.contactEmail ? "error" : ""}
//                                             disabled={isProcessing}
//                                         />
//                                         {errors.contactEmail && (
//                                             <span className="error-text">{errors.contactEmail}</span>
//                                         )}
//                                     </div>
//                                     <div className="form-group">
//                                         <label>Contact Phone *</label>
//                                         <input
//                                             type="tel"
//                                             name="contactPhone"
//                                             value={formData.contactPhone}
//                                             onChange={handleChange}
//                                             placeholder="10-digit phone number"
//                                             className={errors.contactPhone ? "error" : ""}
//                                             disabled={isProcessing}
//                                         />
//                                         {errors.contactPhone && (
//                                             <span className="error-text">{errors.contactPhone}</span>
//                                         )}
//                                     </div>
//                                 </div>

//                                 {/* Capacity */}
//                                 <div className="form-row">
//                                     <div className="form-group">
//                                         <label>Total Spots *</label>
//                                         <input
//                                             type="number"
//                                             name="totalSpots"
//                                             value={formData.totalSpots}
//                                             onChange={handleChange}
//                                             min="1"
//                                             className={errors.totalSpots ? "error" : ""}
//                                             disabled={isProcessing}
//                                         />
//                                         {errors.totalSpots && (
//                                             <span className="error-text">{errors.totalSpots}</span>
//                                         )}
//                                     </div>
//                                     <div className="form-group">
//                                         <label>Registered Count</label>
//                                         <input
//                                             type="number"
//                                             name="registered"
//                                             value={formData.registered}
//                                             onChange={handleChange}
//                                             min="0"
//                                             disabled={isProcessing}
//                                         />
//                                     </div>
//                                     <div className="form-group">
//                                         <label>Progress (%)</label>
//                                         <input
//                                             type="number"
//                                             name="progress"
//                                             value={formData.progress}
//                                             min="0"
//                                             max="100"
//                                             disabled
//                                         />
//                                     </div>
//                                 </div>

//                                 {/* Goal */}
//                                 <div className="form-group">
//                                     <label>Goal / Target</label>
//                                     <input
//                                         type="text"
//                                         name="goal"
//                                         value={formData.goal}
//                                         onChange={handleChange}
//                                         placeholder="e.g. 0,000 or 500 Donors"
//                                         disabled={isProcessing}
//                                     />
//                                 </div>
//                             </div>
//                         </div>

//                         <div className="modal-footer">
//                             <button className="btn-cancel" onClick={closeModal} disabled={isProcessing}>
//                                 Cancel
//                             </button>
//                             <button
//                                 className="btn-submit"
//                                 onClick={handleSubmit}
//                                 disabled={isProcessing}
//                             >
//                                 {isProcessing
//                                     ? "Processing..."
//                                     : editId
//                                     ? "Update Event"
//                                     : "Create Event"}
//                             </button>
//                         </div>
//                     </div>
//                 </div>
//             )}

//             {/* ══════════════════════════════════════════════
//                 VIEW MODAL
//                 ══════════════════════════════════════════════ */}
//             {showViewModal && selectedEvent && (
//                 <div className="modal-overlay">
//                     <div className="modal-container view-modal">
//                         <div className="modal-header">
//                             <h3>Event Details</h3>
//                             <button className="close-btn" onClick={closeViewModal}>
//                                 ×
//                             </button>
//                         </div>

//                         <div className="modal-body">
//                             <div className="event-details">
//                                 {/* Image */}
//                                 {selectedEvent.image_url && (
//                                     <div className="detail-section image-section">
//                                         <h4>Event Image</h4>
//                                         <div className="event-detail-image">
//                                             <img
//                                                 src={selectedEvent.image_url}
//                                                 alt={selectedEvent.title || "Event Image"}
//                                                 loading="lazy"
//                                                 style={{
//                                                     maxWidth: "100%",
//                                                     maxHeight: "300px",
//                                                     objectFit: "contain"
//                                                 }}
//                                             />
//                                         </div>
//                                     </div>
//                                 )}

//                                 {/* Basic Info */}
//                                 <div className="detail-section">
//                                     <h4>Basic Information</h4>
//                                     <div className="detail-row">
//                                         <span className="detail-label">Title:</span>
//                                         <span className="detail-value">
//                                             {selectedEvent.title || "Untitled Event"}
//                                         </span>
//                                     </div>
//                                     <div className="detail-row">
//                                         <span className="detail-label">Category:</span>
//                                         <span
//                                             className={`category-badge category-${(
//                                                 selectedEvent.type || "other"
//                                             ).toLowerCase()}`}
//                                         >
//                                             {selectedEvent.category || "Uncategorized"}
//                                         </span>
//                                     </div>
//                                     <div className="detail-row">
//                                         <span className="detail-label">Status:</span>
//                                         <span
//                                             className={`status-badge status-${(
//                                                 selectedEvent.status || "Upcoming"
//                                             ).toLowerCase()}`}
//                                         >
//                                             {selectedEvent.status || "Upcoming"}
//                                         </span>
//                                     </div>
//                                     <div className="detail-row">
//                                         <span className="detail-label">Event Code:</span>
//                                         <span className="detail-value">
//                                             {selectedEvent.code ||
//                                                 `EVT${selectedEvent.id.toString().slice(-6)}`}
//                                         </span>
//                                     </div>
//                                 </div>

//                                 {/* Date & Location */}
//                                 <div className="detail-section">
//                                     <h4>Date &amp; Location</h4>
//                                     <div className="detail-row">
//                                         <span className="detail-label">Date:</span>
//                                         <span className="detail-value">
//                                             {formatDisplayDate(selectedEvent.date)}
//                                         </span>
//                                     </div>
//                                     <div className="detail-row">
//                                         <span className="detail-label">Full Date:</span>
//                                         <span className="detail-value">
//                                             {selectedEvent.fullDate ||
//                                                 formatDisplayDate(selectedEvent.date)}
//                                         </span>
//                                     </div>
//                                     <div className="detail-row">
//                                         <span className="detail-label">Location:</span>
//                                         <span className="detail-value">
//                                             {selectedEvent.location || "Location not specified"}
//                                         </span>
//                                     </div>
//                                 </div>

//                                 {/* Description */}
//                                 <div className="detail-section">
//                                     <h4>Description</h4>
//                                     <div className="detail-description">
//                                         {selectedEvent.description || "No description provided"}
//                                     </div>
//                                 </div>

//                                 {/* Contact */}
//                                 <div className="detail-section">
//                                     <h4>Contact Information</h4>
//                                     <div className="detail-row">
//                                         <span className="detail-label">Email:</span>
//                                         <span className="detail-value">
//                                             {selectedEvent.contactEmail || "Not provided"}
//                                         </span>
//                                     </div>
//                                     <div className="detail-row">
//                                         <span className="detail-label">Phone:</span>
//                                         <span className="detail-value">
//                                             {selectedEvent.contactPhone || "Not provided"}
//                                         </span>
//                                     </div>
//                                 </div>

//                                 {/* Registration */}
//                                 <div className="detail-section">
//                                     <h4>Registration Details</h4>
//                                     <div className="detail-row">
//                                         <span className="detail-label">Registered:</span>
//                                         <span className="detail-value">
//                                             {parseInt(selectedEvent.registered) || 0} /{" "}
//                                             {parseInt(selectedEvent.totalSpots) || 100}
//                                         </span>
//                                     </div>
//                                     <div className="detail-row">
//                                         <span className="detail-label">Progress:</span>
//                                         <div className="progress-container">
//                                             <div className="progress-bar">
//                                                 <div
//                                                     className="progress-fill"
//                                                     style={{
//                                                         width: `${Math.min(
//                                                             100,
//                                                             parseInt(selectedEvent.progress) || 0
//                                                         )}%`
//                                                     }}
//                                                 ></div>
//                                             </div>
//                                             <span className="progress-percentage">
//                                                 {Math.min(
//                                                     100,
//                                                     parseInt(selectedEvent.progress) || 0
//                                                 )}
//                                                 %
//                                             </span>
//                                         </div>
//                                     </div>
//                                     <div className="detail-row">
//                                         <span className="detail-label">Goal / Target:</span>
//                                         <span className="detail-value">
//                                             {selectedEvent.goal || "0,000"}
//                                         </span>
//                                     </div>
//                                 </div>

//                                 {/* System Info */}
//                                 <div className="detail-section">
//                                     <h4>System Information</h4>
//                                     <div className="detail-row">
//                                         <span className="detail-label">Created At:</span>
//                                         <span className="detail-value">
//                                             {selectedEvent.created_at
//                                                 ? new Date(selectedEvent.created_at).toLocaleString()
//                                                 : "Not available"}
//                                         </span>
//                                     </div>
//                                     <div className="detail-row">
//                                         <span className="detail-label">Event ID:</span>
//                                         <span className="detail-value">{selectedEvent.id}</span>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>

//                         <div className="modal-footer">
//                             <button className="btn-close" onClick={closeViewModal}>
//                                 Close
//                             </button>
//                         </div>
//                     </div>
//                 </div>
//             )}
//         </div>
//     );
// }
export default function Events() {
    const [events, setEvents] = useState([]);
    const [editId, setEditId] = useState(null);
    const [filter, setFilter] = useState("All Categories");
    const [sortOrder, setSortOrder] = useState("upcoming-first");
    const [searchTerm, setSearchTerm] = useState("");
    const [selectedEvent, setSelectedEvent] = useState(null);
    const [showCreateModal, setShowCreateModal] = useState(false);
    const [showViewModal, setShowViewModal] = useState(false);
    const [imageFile, setImageFile] = useState(null);
    const [imagePreview, setImagePreview] = useState(null);
    const [loading, setLoading] = useState(false);
    const [isProcessing, setIsProcessing] = useState(false);

    const fileInputRef = useRef(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const ITEMS_PER_PAGE = 5;

    // ── Form fields ──
    const defaultForm = () => ({
        title: "",
        category: "Healthcare",
        description: "",
        status: "Upcoming",
        date: "",
        fullDate: "",
        code: `EVT${Date.now().toString().slice(-6)}`,
        goal: "0,000",
        type: "health",
        location: "",
        contactEmail: "",
        contactPhone: "",
        totalSpots: "100",
        registered: "0",
        progress: "0"
    });

    const [formData, setFormData] = useState(defaultForm());
    const [errors, setErrors] = useState({});

    const categories = ["Healthcare", "Education", "Tracking", "Activism", "Environment", "Other"];
    const API_URL = process.env.REACT_APP_API_URL;
    const img_URL = process.env.REACT_APP_API_URL;

    // ─────────────────────────────────────────────────────
    // SAFE JSON PARSER
    // ─────────────────────────────────────────────────────
    const safeJson = async (res) => {
        const text = await res.text();
        try {
            return JSON.parse(text);
        } catch (err) {
            console.error("═══ RAW PHP RESPONSE (not JSON) ═══\n", text);
            throw new Error(`Server returned HTTP ${res.status} — see console for details`);
        }
    };

    // ─────────────────────────────────────────────────────
    // FETCH EVENTS - with pagination
    // ─────────────────────────────────────────────────────
    const fetchEvents = useCallback(async (page = 1) => {
        setLoading(true);
        try {
            const res = await fetch(`${API_URL}Event.php?page=${page}&limit=${ITEMS_PER_PAGE}`);
            const data = await safeJson(res);

            if (data.success && Array.isArray(data.data)) {
                const eventsWithImages = data.data.map((event) => ({
                    ...event,
                    image_url: event.image ? `${img_URL}${event.image}` : null
                }));

                setEvents(eventsWithImages);

                if (data.pagination) {
                    setCurrentPage(data.pagination.page);
                    setTotalPages(data.pagination.totalPages || data.pagination.total_pages || 1);
                    setTotalCount(data.pagination.total);
                }
            } else {
                console.error("Failed to fetch events:", data.error || data.message);
                setEvents([]);
                setTotalCount(0);
                setTotalPages(1);
            }
        } catch (err) {
            console.error("Error fetching events:", err);
            setEvents([]);
            setTotalCount(0);
            setTotalPages(1);
        } finally {
            setLoading(false);
        }
    }, [API_URL, img_URL, ITEMS_PER_PAGE]);

    useEffect(() => {
        fetchEvents(1);
    }, [fetchEvents]);

    // ─────────────────────────────────────────────────────
    // IMAGE HANDLING
    // ─────────────────────────────────────────────────────
    const handleImageChange = (e) => {
        const file = e.target.files?.[0];
        if (!file) return;

        const validTypes = ["image/jpeg", "image/png", "image/webp", "image/jpg"];
        if (!validTypes.includes(file.type)) {
            alert("Only JPG, PNG, and WebP images are allowed");
            return;
        }

        if (file.size > 2 * 1024 * 1024) {
            alert("Image must be under 2MB");
            return;
        }

        setImageFile(file);

        const reader = new FileReader();
        reader.onloadend = () => setImagePreview(reader.result);
        reader.onerror = () => alert("Failed to read image file");
        reader.readAsDataURL(file);
    };

    const removeImage = () => {
        setImageFile(null);
        setImagePreview(null);
        if (fileInputRef.current) {
            fileInputRef.current.value = "";
        }
    };

    // ─────────────────────────────────────────────────────
    // VALIDATION
    // ─────────────────────────────────────────────────────
    const validateForm = () => {
        const newErrors = {};

        if (!formData.title.trim()) {
            newErrors.title = "Event title is required";
        } else if (formData.title.length < 5) {
            newErrors.title = "Title must be at least 5 characters";
        }

        if (!formData.description.trim()) {
            newErrors.description = "Description is required";
        } else if (formData.description.length < 20) {
            newErrors.description = "Description must be at least 20 characters";
        }

        if (!formData.date) {
            newErrors.date = "Event date is required";
        } else if (!editId && new Date(formData.date) < new Date().setHours(0, 0, 0, 0)) {
            newErrors.date = "Event date cannot be in the past";
        }

        if (!formData.location.trim()) {
            newErrors.location = "Location is required";
        }

        if (!formData.contactEmail.trim()) {
            newErrors.contactEmail = "Contact email is required";
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.contactEmail)) {
            newErrors.contactEmail = "Invalid email format";
        }

        if (!formData.contactPhone.trim()) {
            newErrors.contactPhone = "Contact phone is required";
        } else if (!/^\d{10}$/.test(formData.contactPhone.replace(/\D/g, ''))) {
            newErrors.contactPhone = "Phone number must be 10 digits";
        }

        const totalSpots = parseInt(formData.totalSpots);
        if (!totalSpots || totalSpots < 1) {
            newErrors.totalSpots = "Total spots must be at least 1";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        const newFormData = { ...formData, [name]: value };

        if (name === "date" && value) {
            try {
                const dateObj = new Date(value);
                newFormData.fullDate = dateObj.toLocaleDateString("en-US", {
                    year: "numeric",
                    month: "long",
                    day: "numeric"
                });
            } catch {
                newFormData.fullDate = value;
            }
        }

        if (name === "registered" || name === "totalSpots") {
            const registered = parseInt(newFormData.registered) || 0;
            const totalSpots = parseInt(newFormData.totalSpots) || 1;
            newFormData.progress = Math.min(100, Math.round((registered / totalSpots) * 100)).toString();
        }

        setFormData(newFormData);
        if (errors[name]) {
            setErrors((prev) => {
                const newErrors = { ...prev };
                delete newErrors[name];
                return newErrors;
            });
        }
    };

    // ─────────────────────────────────────────────────────
    // MODAL HELPERS
    // ─────────────────────────────────────────────────────
    const openCreateModal = () => {
        setFormData(defaultForm());
        setEditId(null);
        setImageFile(null);
        setImagePreview(null);
        setErrors({});
        setShowCreateModal(true);
    };

    const openEditModal = (event) => {
        setFormData({
            title: event.title || "",
            category: event.category || "Healthcare",
            description: event.description || "",
            status: event.status || "Upcoming",
            date: event.date || "",
            fullDate: event.fullDate || "",
            code: event.code || `EVT${Date.now().toString().slice(-6)}`,
            goal: event.goal || "0,000",
            type: event.type || "health",
            location: event.location || "",
            contactEmail: event.contactEmail || "",
            contactPhone: event.contactPhone || "",
            totalSpots: event.totalSpots?.toString() || "100",
            registered: event.registered?.toString() || "0",
            progress: event.progress?.toString() || "0"
        });
        setEditId(event.id);
        setImageFile(null);
        setImagePreview(event.image_url || null);
        setErrors({});
        setShowCreateModal(true);
    };

    const closeModal = () => {
        setShowCreateModal(false);
        setEditId(null);
        setFormData(defaultForm());
        setImageFile(null);
        setImagePreview(null);
        setErrors({});
    };

    // ─────────────────────────────────────────────────────
    // SUBMIT - CREATE & UPDATE
    // ─────────────────────────────────────────────────────
    const handleSubmit = async () => {
        if (!validateForm()) {
            alert("Please fix validation errors");
            return;
        }

        setIsProcessing(true);

        const fd = new FormData();
        Object.entries(formData).forEach(([key, val]) => {
            fd.append(key, val != null ? String(val) : "");
        });

        if (imageFile) {
            fd.append("image", imageFile, imageFile.name);
        }

        try {
            if (editId) {
                fd.append("id", String(editId));
                fd.append("_method", "PUT");
            }

            const res = await fetch(`${API_URL}Event.php`, {
                method: "POST",
                body: fd
            });

            const result = await safeJson(res);

            if (result.success) {
                alert(editId ? "Event Updated Successfully" : "Event Created Successfully");
                closeModal();
                fetchEvents(currentPage);
            } else {
                alert(result.error || result.message || "Operation failed");
            }
        } catch (err) {
            console.error("Submit error:", err);
            alert("Server error. Please try again.");
        } finally {
            setIsProcessing(false);
        }
    };

    // ─────────────────────────────────────────────────────
    // DELETE
    // ─────────────────────────────────────────────────────
    const handleDelete = async (id) => {
        if (!window.confirm("Are you sure you want to delete this event? This action cannot be undone.")) {
            return;
        }

        setIsProcessing(true);
        try {
            const res = await fetch(`${API_URL}Event.php`, {
                method: "DELETE",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ id: Number(id) })
            });

            const result = await safeJson(res);

            if (result.success) {
                alert("Event deleted successfully!");
                const newPage = events.length === 1 && currentPage > 1 ? currentPage - 1 : currentPage;
                fetchEvents(newPage);
            } else {
                alert(result.error || result.message || "Failed to delete event");
            }
        } catch (err) {
            console.error("Delete error:", err);
            alert("Failed to delete event. Please try again.");
        } finally {
            setIsProcessing(false);
        }
    };

    // ─────────────────────────────────────────────────────
    // STATUS CHANGE - FIXED (No CORS header)
    // ─────────────────────────────────────────────────────
    const handleStatusChange = async (id, newStatus) => {
        const event = events.find((e) => e.id === id);
        if (!event) return;

        setIsProcessing(true);
        try {
            const fd = new FormData();
            fd.append("id", String(id));
            fd.append("_method", "PUT");
            fd.append("title", event.title || "");
            fd.append("category", event.category || "");
            fd.append("description", event.description || "");
            fd.append("status", newStatus);
            fd.append("date", event.date || "");
            fd.append("fullDate", event.fullDate || "");
            fd.append("code", event.code || "");
            fd.append("goal", event.goal || "");
            fd.append("type", event.type || "");
            fd.append("location", event.location || "");
            fd.append("contactEmail", event.contactEmail || "");
            fd.append("contactPhone", event.contactPhone || "");
            fd.append("totalSpots", String(event.totalSpots ?? 100));
            fd.append("registered", String(event.registered ?? 0));
            fd.append("progress", String(event.progress ?? 0));

            // ✅ Don't send image file, keep existing image path
            if (event.image) {
                fd.append("image", event.image);
            }

            const res = await fetch(`${API_URL}Event.php`, {
                method: "POST",
                body: fd
            });

            const result = await safeJson(res);

            if (result.success) {
                setEvents((prev) =>
                    prev.map((e) => (e.id === id ? { ...e, status: newStatus } : e))
                );
                alert("Status updated successfully!");
            } else {
                alert(result.error || result.message || "Failed to update status");
            }
        } catch (err) {
            console.error("Status change error:", err);
            alert("Failed to update status");
        } finally {
            setIsProcessing(false);
        }
    };

    // ─────────────────────────────────────────────────────
    // REGISTRATION (+1) - FIXED (No CORS header)
    // ─────────────────────────────────────────────────────
    const handleRegistration = async (id) => {
        const event = events.find((e) => e.id === id);
        if (!event) return;

        if (event.status !== "Upcoming") {
            alert("Cannot register for completed or cancelled events");
            return;
        }

        const currentRegistered = parseInt(event.registered) || 0;
        const totalSpots = parseInt(event.totalSpots) || 100;

        if (currentRegistered >= totalSpots) {
            alert("Event is full! No more spots available.");
            return;
        }

        const newRegistered = currentRegistered + 1;
        const newProgress = Math.min(100, Math.round((newRegistered / totalSpots) * 100));

        setIsProcessing(true);
        try {
            const fd = new FormData();
            fd.append("id", String(id));
            fd.append("_method", "PUT");
            fd.append("title", event.title || "");
            fd.append("category", event.category || "");
            fd.append("description", event.description || "");
            fd.append("status", event.status || "Upcoming");
            fd.append("date", event.date || "");
            fd.append("fullDate", event.fullDate || "");
            fd.append("code", event.code || "");
            fd.append("goal", event.goal || "");
            fd.append("type", event.type || "");
            fd.append("location", event.location || "");
            fd.append("contactEmail", event.contactEmail || "");
            fd.append("contactPhone", event.contactPhone || "");
            fd.append("totalSpots", String(totalSpots));
            fd.append("registered", String(newRegistered));
            fd.append("progress", String(newProgress));

            // ✅ Keep existing image
            if (event.image) {
                fd.append("image", event.image);
            }

            const res = await fetch(`${API_URL}Event.php`, {
                method: "POST",
                body: fd
            });

            const result = await safeJson(res);

            if (result.success) {
                setEvents((prev) =>
                    prev.map((e) =>
                        e.id === id
                            ? {
                                  ...e,
                                  registered: newRegistered.toString(),
                                  progress: newProgress.toString()
                              }
                            : e
                    )
                );
                alert(`Registration added! Total registered: ${newRegistered}/${totalSpots}`);
            } else {
                alert(result.error || result.message || "Failed to add registration");
            }
        } catch (err) {
            console.error("Registration error:", err);
            alert("Failed to add registration");
        } finally {
            setIsProcessing(false);
        }
    };

    // ─────────────────────────────────────────────────────
    // VIEW MODAL
    // ─────────────────────────────────────────────────────
    const handleViewDetails = (event) => {
        setSelectedEvent(event);
        setShowViewModal(true);
    };

    const closeViewModal = () => {
        setShowViewModal(false);
        setSelectedEvent(null);
    };

    // ─────────────────────────────────────────────────────
    // CLIENT-SIDE FILTER & SORT
    // ─────────────────────────────────────────────────────
    const filteredEvents = events.filter((event) => {
        const matchesCategory = filter === "All Categories" || event.category === filter;
        const matchesSearch =
            searchTerm === "" ||
            (event.title || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
            (event.description || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
            (event.location || "").toLowerCase().includes(searchTerm.toLowerCase());
        return matchesCategory && matchesSearch;
    });

    const sortedEvents = [...filteredEvents].sort((a, b) => {
        const dateA = new Date(a.date);
        const dateB = new Date(b.date);
        switch (sortOrder) {
            case "upcoming-first":
                return dateA - dateB;
            case "date-desc":
                return dateB - dateA;
            case "upcoming-only":
                return a.status === "Upcoming" ? -1 : 1;
            case "completed-first":
                return a.status === "Completed" ? -1 : 1;
            case "registered-desc":
                return (parseInt(b.registered) || 0) - (parseInt(a.registered) || 0);
            default:
                return 0;
        }
    });

    const displayedEvents =
        sortOrder === "upcoming-only"
            ? sortedEvents.filter((e) => e.status === "Upcoming")
            : sortedEvents;

    // ─────────────────────────────────────────────────────
    // PAGINATION
    // ─────────────────────────────────────────────────────
    const goToPage = (page) => {
        if (page < 1 || page > totalPages || isProcessing) return;
        fetchEvents(page);
    };

    // ─────────────────────────────────────────────────────
    // STATISTICS (from current page data)
    // ─────────────────────────────────────────────────────
    const upcomingEvents = events.filter((e) => e.status === "Upcoming").length;
    const completedEvents = events.filter((e) => e.status === "Completed").length;
    const totalRegistrations = events.reduce((sum, e) => sum + (parseInt(e.registered) || 0), 0);

    // ─────────────────────────────────────────────────────
    // DATE FORMATTER
    // ─────────────────────────────────────────────────────
    const formatDisplayDate = (dateString) => {
        if (!dateString) return "Date not set";
        try {
            const date = new Date(dateString);
            if (isNaN(date.getTime())) return dateString;
            return date.toLocaleDateString("en-US", {
                year: "numeric",
                month: "short",
                day: "numeric"
            });
        } catch {
            return dateString;
        }
    };

    // ═════════════════════════════════════════════════════
    // RENDER
    // ═════════════════════════════════════════════════════
    return (
        <div className="events-admin">
            {/* ── Header ── */}
            <div className="events-header">
                <div className="header-top">
                    <h2>
                        <span>📅</span> Event Management
                    </h2>
                    <button className="btn-create" onClick={openCreateModal} disabled={isProcessing}>
                        <span>+</span> Create New Event
                    </button>
                </div>
                <p className="subtitle">Manage and organize all community events</p>

                <div className="filters-section">
                    <div className="search-bar">
                        <input
                            type="text"
                            placeholder="Search events by title, description, or location..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            disabled={isProcessing}
                        />
                    </div>
                    <div className="filters">
                        <div className="filter-group">
                            <label>Category:</label>
                            <select
                                value={filter}
                                onChange={(e) => setFilter(e.target.value)}
                                className="filter-select"
                                disabled={isProcessing}
                            >
                                <option value="All Categories">All Categories</option>
                                {categories.map((cat) => (
                                    <option key={cat} value={cat}>
                                        {cat}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="filter-group">
                            <label>Sort By:</label>
                            <select
                                value={sortOrder}
                                onChange={(e) => setSortOrder(e.target.value)}
                                className="sort-select"
                                disabled={isProcessing}
                            >
                                <option value="upcoming-first">Date (Earliest First)</option>
                                <option value="date-desc">Date (Latest First)</option>
                                <option value="upcoming-only">Upcoming Only</option>
                                <option value="completed-first">Completed First</option>
                                <option value="registered-desc">Most Registered</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>

            {loading ? (
                <div className="loading-state">
                    <div className="loading-spinner"></div>
                    <p>Loading events...</p>
                </div>
            ) : (
                <>
                    <div className="events-stats">
                        <div className="stat-card">
                            <div className="stat-icon">📅</div>
                            <div className="stat-content">
                                <h3>{totalCount}</h3>
                                <p>Total Events</p>
                            </div>
                        </div>
                        <div className="stat-card">
                            <div className="stat-icon">⏳</div>
                            <div className="stat-content">
                                <h3>{upcomingEvents}</h3>
                                <p>Upcoming</p>
                            </div>
                        </div>
                        <div className="stat-card">
                            <div className="stat-icon">✅</div>
                            <div className="stat-content">
                                <h3>{completedEvents}</h3>
                                <p>Completed</p>
                            </div>
                        </div>
                        <div className="stat-card">
                            <div className="stat-icon">👥</div>
                            <div className="stat-content">
                                <h3>{totalRegistrations}</h3>
                                <p>Total Registrations</p>
                            </div>
                        </div>
                    </div>

                    <div className="events-list-container">
                        <div className="list-header">
                            <h3>All Events ({totalCount})</h3>
                            <div className="table-actions">
                                <span className="results-count">
                                    Showing {displayedEvents.length} of {totalCount} events · Page{" "}
                                    {currentPage} of {totalPages}
                                </span>
                            </div>
                        </div>

                        {displayedEvents.length === 0 ? (
                            <div className="empty-state">
                                <div className="empty-icon">📅</div>
                                <p>No events found</p>
                                <p className="empty-subtext">
                                    {searchTerm || filter !== "All Categories"
                                        ? "Try a different search or filter"
                                        : "Create your first event to get started"}
                                </p>
                                <button
                                    className="btn-create-empty"
                                    onClick={openCreateModal}
                                    disabled={isProcessing}
                                >
                                    Create New Event
                                </button>
                            </div>
                        ) : (
                            <>
                                <div className="events-table">
                                    <table>
                                        <thead>
                                            <tr>
                                                <th>Event</th>
                                                <th>Category</th>
                                                <th>Date</th>
                                                <th>Status</th>
                                                <th>Registrations</th>
                                                <th>Progress</th>
                                                <th>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {displayedEvents.map((event) => (
                                                <tr key={event.id}>
                                                    <td className="event-info">
                                                        <div className="event-title">
                                                            {event.title || "Untitled Event"}
                                                        </div>
                                                        <div className="event-code">
                                                            {event.code || `EVT${event.id.toString().slice(-6)}`}
                                                        </div>
                                                        {event.image_url && (
                                                            <div className="event-image-indicator" title="Has image">
                                                                📷
                                                            </div>
                                                        )}
                                                    </td>
                                                    <td className="event-category">
                                                        <span
                                                            className={`category-badge category-${(
                                                                event.type || "other"
                                                            ).toLowerCase()}`}
                                                        >
                                                            {event.category || "Uncategorized"}
                                                        </span>
                                                    </td>
                                                    <td className="event-date">{formatDisplayDate(event.date)}</td>
                                                    <td className="event-status">
                                                        <select
                                                            value={event.status || "Upcoming"}
                                                            onChange={(e) =>
                                                                handleStatusChange(event.id, e.target.value)
                                                            }
                                                            className={`status-select status-${(
                                                                event.status || "Upcoming"
                                                            ).toLowerCase()}`}
                                                            disabled={isProcessing}
                                                        >
                                                            <option value="Upcoming">Upcoming</option>
                                                            <option value="Completed">Completed</option>
                                                            <option value="Cancelled">Cancelled</option>
                                                        </select>
                                                    </td>
                                                    <td className="event-registered">
                                                        <div className="registration-count">
                                                            {parseInt(event.registered) || 0} /{" "}
                                                            {parseInt(event.totalSpots) || 100}
                                                        </div>
                                                        <div className="registration-text">Registered</div>
                                                    </td>
                                                    <td className="event-progress">
                                                        <div className="progress-container">
                                                            <div className="progress-bar">
                                                                <div
                                                                    className="progress-fill"
                                                                    style={{
                                                                        width: `${Math.min(
                                                                            100,
                                                                            parseInt(event.progress) || 0
                                                                        )}%`
                                                                    }}
                                                                ></div>
                                                            </div>
                                                            <span className="progress-percentage">
                                                                {Math.min(100, parseInt(event.progress) || 0)}%
                                                            </span>
                                                        </div>
                                                    </td>
                                                    <td className="event-actions">
                                                        <div className="action-buttons">
                                                            <button
                                                                className="btn-view"
                                                                onClick={() => handleViewDetails(event)}
                                                                title="View Details"
                                                                disabled={isProcessing}
                                                            >
                                                                👁️
                                                            </button>
                                                            <button
                                                                className="btn-edit"
                                                                onClick={() => openEditModal(event)}
                                                                title="Edit Event"
                                                                disabled={isProcessing}
                                                            >
                                                                ✏️
                                                            </button>
                                                            <button
                                                                className="btn-register"
                                                                onClick={() => handleRegistration(event.id)}
                                                                disabled={isProcessing || event.status !== "Upcoming"}
                                                                title="Add Registration"
                                                            >
                                                                ➕
                                                            </button>
                                                            <button
                                                                className="btn-delete"
                                                                onClick={() => handleDelete(event.id)}
                                                                title="Delete Event"
                                                                disabled={isProcessing}
                                                            >
                                                                🗑️
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>

                                <div className="pagination">
                                    <button
                                        className="pagination-btn prev"
                                        onClick={() => goToPage(currentPage - 1)}
                                        disabled={currentPage === 1 || isProcessing}
                                    >
                                        ← Previous
                                    </button>

                                    <div className="pagination-numbers">
                                        {Array.from({ length: Math.min(totalPages, 10) }, (_, i) => {
                                            let pageNum;
                                            if (totalPages <= 10) {
                                                pageNum = i + 1;
                                            } else if (currentPage <= 5) {
                                                pageNum = i + 1;
                                            } else if (currentPage >= totalPages - 4) {
                                                pageNum = totalPages - 9 + i;
                                            } else {
                                                pageNum = currentPage - 5 + i;
                                            }
                                            return (
                                                <button
                                                    key={pageNum}
                                                    className={`pagination-number ${
                                                        currentPage === pageNum ? "active" : ""
                                                    }`}
                                                    onClick={() => goToPage(pageNum)}
                                                    disabled={isProcessing}
                                                >
                                                    {pageNum}
                                                </button>
                                            );
                                        })}
                                    </div>

                                    <button
                                        className="pagination-btn next"
                                        onClick={() => goToPage(currentPage + 1)}
                                        disabled={currentPage === totalPages || isProcessing}
                                    >
                                        Next →
                                    </button>

                                    <div className="page-info">
                                        Page {currentPage} of {totalPages}
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                </>
            )}

            {/* CREATE/EDIT MODAL */}
            {showCreateModal && (
                <div className="modal-overlay" onClick={(e) => e.target === e.currentTarget && closeModal()}>
                    <div className="modal-container">
                        <div className="modal-header">
                            <h3>{editId ? "Edit Event" : "Create New Event"}</h3>
                            <button className="close-btn" onClick={closeModal} disabled={isProcessing}>
                                ×
                            </button>
                        </div>

                        <div className="modal-body">
                            <div className="modal-form">
                                {/* Image Upload */}
                                <div className="form-group">
                                    <label>Event Image</label>
                                    <div className="image-upload-container">
                                        <input
                                            ref={fileInputRef}
                                            type="file"
                                            accept="image/jpeg,image/png,image/webp,image/jpg"
                                            onChange={handleImageChange}
                                            style={{ display: "none" }}
                                            disabled={isProcessing}
                                        />

                                        {imagePreview ? (
                                            <div className="image-preview">
                                                <img
                                                    src={imagePreview}
                                                    alt="Preview"
                                                    onError={(e) => {
                                                        e.target.src = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='200' height='200'%3E%3Crect fill='%23ddd' width='200' height='200'/%3E%3Ctext fill='%23999' x='50%25' y='50%25' text-anchor='middle' dy='.3em'%3EImage Error%3C/text%3E%3C/svg%3E";
                                                    }}
                                                    style={{
                                                        width: "100%",
                                                        height: "auto",
                                                        maxHeight: "200px",
                                                        objectFit: "contain"
                                                    }}
                                                />
                                                <div style={{ display: "flex", gap: "8px", marginTop: "8px" }}>
                                                    <button
                                                        type="button"
                                                        className="remove-image-btn"
                                                        onClick={removeImage}
                                                        disabled={isProcessing}
                                                    >
                                                        Remove Image
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="remove-image-btn"
                                                        onClick={() => fileInputRef.current?.click()}
                                                        disabled={isProcessing}
                                                    >
                                                        Change Image
                                                    </button>
                                                </div>
                                            </div>
                                        ) : (
                                            <div
                                                className="image-upload-area"
                                                onClick={() => !isProcessing && fileInputRef.current?.click()}
                                                style={{ cursor: isProcessing ? "not-allowed" : "pointer" }}
                                            >
                                                <div className="upload-icon">📷</div>
                                                <div className="upload-text">Click to upload event image</div>
                                                <div className="upload-subtext">JPG, PNG, WebP (max 2MB)</div>
                                            </div>
                                        )}
                                    </div>
                                </div>

                                {/* Rest of the form fields remain the same... */}
                                <div className="form-row">
                                    <div className="form-group">
                                        <label>Event Title *</label>
                                        <input
                                            type="text"
                                            name="title"
                                            value={formData.title}
                                            onChange={handleChange}
                                            placeholder="Enter event title"
                                            className={errors.title ? "error" : ""}
                                            disabled={isProcessing}
                                        />
                                        {errors.title && <span className="error-text">{errors.title}</span>}
                                    </div>
                                    <div className="form-group">
                                        <label>Category *</label>
                                        <select
                                            name="category"
                                            value={formData.category}
                                            onChange={handleChange}
                                            disabled={isProcessing}
                                        >
                                            {categories.map((cat) => (
                                                <option key={cat} value={cat}>
                                                    {cat}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>

                                <div className="form-row">
                                    <div className="form-group">
                                        <label>Event Date *</label>
                                        <input
                                            type="date"
                                            name="date"
                                            value={formData.date}
                                            onChange={handleChange}
                                            className={errors.date ? "error" : ""}
                                            disabled={isProcessing}
                                        />
                                        {errors.date && <span className="error-text">{errors.date}</span>}
                                    </div>
                                    <div className="form-group">
                                        <label>Event Code</label>
                                        <input
                                            type="text"
                                            name="code"
                                            value={formData.code}
                                            onChange={handleChange}
                                            placeholder="Event code"
                                            disabled={isProcessing}
                                        />
                                    </div>
                                </div>

                                <div className="form-row">
                                    <div className="form-group">
                                        <label>Status *</label>
                                        <select name="status" value={formData.status} onChange={handleChange} disabled={isProcessing}>
                                            <option value="Upcoming">Upcoming</option>
                                            <option value="Completed">Completed</option>
                                            <option value="Cancelled">Cancelled</option>
                                        </select>
                                    </div>
                                    <div className="form-group">
                                        <label>Event Type</label>
                                        <select name="type" value={formData.type} onChange={handleChange} disabled={isProcessing}>
                                            <option value="health">Health</option>
                                            <option value="education">Education</option>
                                            <option value="tracking">Tracking</option>
                                            <option value="campaign">Campaign</option>
                                            <option value="environment">Environment</option>
                                            <option value="other">Other</option>
                                        </select>
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label>Location *</label>
                                    <input
                                        type="text"
                                        name="location"
                                        value={formData.location}
                                        onChange={handleChange}
                                        placeholder="Enter event location"
                                        className={errors.location ? "error" : ""}
                                        disabled={isProcessing}
                                    />
                                    {errors.location && <span className="error-text">{errors.location}</span>}
                                </div>

                                <div className="form-group">
                                    <label>Description *</label>
                                    <textarea
                                        name="description"
                                        value={formData.description}
                                        onChange={handleChange}
                                        placeholder="Describe the event in detail..."
                                        rows="4"
                                        className={errors.description ? "error" : ""}
                                        disabled={isProcessing}
                                    />
                                    {errors.description && <span className="error-text">{errors.description}</span>}
                                </div>

                                <div className="form-row">
                                    <div className="form-group">
                                        <label>Contact Email *</label>
                                        <input
                                            type="email"
                                            name="contactEmail"
                                            value={formData.contactEmail}
                                            onChange={handleChange}
                                            placeholder="contact@example.com"
                                            className={errors.contactEmail ? "error" : ""}
                                            disabled={isProcessing}
                                        />
                                        {errors.contactEmail && <span className="error-text">{errors.contactEmail}</span>}
                                    </div>
                                    <div className="form-group">
                                        <label>Contact Phone *</label>
                                        <input
                                            type="tel"
                                            name="contactPhone"
                                            value={formData.contactPhone}
                                            onChange={handleChange}
                                            placeholder="10-digit phone number"
                                            className={errors.contactPhone ? "error" : ""}
                                            disabled={isProcessing}
                                        />
                                        {errors.contactPhone && <span className="error-text">{errors.contactPhone}</span>}
                                    </div>
                                </div>

                                <div className="form-row">
                                    <div className="form-group">
                                        <label>Total Spots *</label>
                                        <input
                                            type="number"
                                            name="totalSpots"
                                            value={formData.totalSpots}
                                            onChange={handleChange}
                                            min="1"
                                            className={errors.totalSpots ? "error" : ""}
                                            disabled={isProcessing}
                                        />
                                        {errors.totalSpots && <span className="error-text">{errors.totalSpots}</span>}
                                    </div>
                                    <div className="form-group">
                                        <label>Registered Count</label>
                                        <input
                                            type="number"
                                            name="registered"
                                            value={formData.registered}
                                            onChange={handleChange}
                                            min="0"
                                            disabled={isProcessing}
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label>Progress (%)</label>
                                        <input type="number" name="progress" value={formData.progress} min="0" max="100" disabled />
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label>Goal / Target</label>
                                    <input
                                        type="text"
                                        name="goal"
                                        value={formData.goal}
                                        onChange={handleChange}
                                        placeholder="e.g. 0,000 or 500 Donors"
                                        disabled={isProcessing}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="modal-footer">
                            <button className="btn-cancel" onClick={closeModal} disabled={isProcessing}>
                                Cancel
                            </button>
                            <button className="btn-submit" onClick={handleSubmit} disabled={isProcessing}>
                                {isProcessing ? "Processing..." : editId ? "Update Event" : "Create Event"}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* VIEW MODAL - remains the same as original */}
            {showViewModal && selectedEvent && (
                <div className="modal-overlay" onClick={(e) => e.target === e.currentTarget && closeViewModal()}>
                    <div className="modal-container view-modal">
                        <div className="modal-header">
                            <h3>Event Details</h3>
                            <button className="close-btn" onClick={closeViewModal}>
                                ×
                            </button>
                        </div>

                        <div className="modal-body">
                            <div className="event-details">
                                {selectedEvent.image_url && (
                                    <div className="detail-section image-section">
                                        <h4>Event Image</h4>
                                        <div className="event-detail-image">
                                            <img
                                                src={selectedEvent.image_url}
                                                alt={selectedEvent.title || "Event Image"}
                                                loading="lazy"
                                                onError={(e) => {
                                                    e.target.src = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='300' height='200'%3E%3Crect fill='%23f0f0f0' width='300' height='200'/%3E%3Ctext fill='%23999' x='50%25' y='50%25' text-anchor='middle' dy='.3em'%3EImage not available%3C/text%3E%3C/svg%3E";
                                                }}
                                                style={{
                                                    maxWidth: "100%",
                                                    maxHeight: "300px",
                                                    objectFit: "contain"
                                                }}
                                            />
                                        </div>
                                    </div>
                                )}

                                <div className="detail-section">
                                    <h4>Basic Information</h4>
                                    <div className="detail-row">
                                        <span className="detail-label">Title:</span>
                                        <span className="detail-value">{selectedEvent.title || "Untitled Event"}</span>
                                    </div>
                                    <div className="detail-row">
                                        <span className="detail-label">Category:</span>
                                        <span className={`category-badge category-${(selectedEvent.type || "other").toLowerCase()}`}>
                                            {selectedEvent.category || "Uncategorized"}
                                        </span>
                                    </div>
                                    <div className="detail-row">
                                        <span className="detail-label">Status:</span>
                                        <span className={`status-badge status-${(selectedEvent.status || "Upcoming").toLowerCase()}`}>
                                            {selectedEvent.status || "Upcoming"}
                                        </span>
                                    </div>
                                    <div className="detail-row">
                                        <span className="detail-label">Event Code:</span>
                                        <span className="detail-value">
                                            {selectedEvent.code || `EVT${selectedEvent.id.toString().slice(-6)}`}
                                        </span>
                                    </div>
                                </div>

                                <div className="detail-section">
                                    <h4>Date & Location</h4>
                                    <div className="detail-row">
                                        <span className="detail-label">Date:</span>
                                        <span className="detail-value">{formatDisplayDate(selectedEvent.date)}</span>
                                    </div>
                                    <div className="detail-row">
                                        <span className="detail-label">Full Date:</span>
                                        <span className="detail-value">
                                            {selectedEvent.fullDate || formatDisplayDate(selectedEvent.date)}
                                        </span>
                                    </div>
                                    <div className="detail-row">
                                        <span className="detail-label">Location:</span>
                                        <span className="detail-value">{selectedEvent.location || "Location not specified"}</span>
                                    </div>
                                </div>

                                <div className="detail-section">
                                    <h4>Description</h4>
                                    <div className="detail-description">{selectedEvent.description || "No description provided"}</div>
                                </div>

                                <div className="detail-section">
                                    <h4>Contact Information</h4>
                                    <div className="detail-row">
                                        <span className="detail-label">Email:</span>
                                        <span className="detail-value">{selectedEvent.contactEmail || "Not provided"}</span>
                                    </div>
                                    <div className="detail-row">
                                        <span className="detail-label">Phone:</span>
                                        <span className="detail-value">{selectedEvent.contactPhone || "Not provided"}</span>
                                    </div>
                                </div>

                                <div className="detail-section">
                                    <h4>Registration Details</h4>
                                    <div className="detail-row">
                                        <span className="detail-label">Registered:</span>
                                        <span className="detail-value">
                                            {parseInt(selectedEvent.registered) || 0} / {parseInt(selectedEvent.totalSpots) || 100}
                                        </span>
                                    </div>
                                    <div className="detail-row">
                                        <span className="detail-label">Progress:</span>
                                        <div className="progress-container">
                                            <div className="progress-bar">
                                                <div
                                                    className="progress-fill"
                                                    style={{
                                                        width: `${Math.min(100, parseInt(selectedEvent.progress) || 0)}%`
                                                    }}
                                                ></div>
                                            </div>
                                            <span className="progress-percentage">
                                                {Math.min(100, parseInt(selectedEvent.progress) || 0)}%
                                            </span>
                                        </div>
                                    </div>
                                    <div className="detail-row">
                                        <span className="detail-label">Goal / Target:</span>
                                        <span className="detail-value">{selectedEvent.goal || "0,000"}</span>
                                    </div>
                                </div>

                                <div className="detail-section">
                                    <h4>System Information</h4>
                                    <div className="detail-row">
                                        <span className="detail-label">Created At:</span>
                                        <span className="detail-value">
                                            {selectedEvent.created_at
                                                ? new Date(selectedEvent.created_at).toLocaleString()
                                                : "Not available"}
                                        </span>
                                    </div>
                                    <div className="detail-row">
                                        <span className="detail-label">Event ID:</span>
                                        <span className="detail-value">{selectedEvent.id}</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="modal-footer">
                            <button className="btn-close" onClick={closeViewModal}>
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}